// AI Generated File
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PolicyFormHelperService } from '@client/app/blocks/helpers/policy-form-helper/policy-form.helper.service';

import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'form-global-policy-dialog-rule',
    templateUrl: './rule.html',
    standalone: false,
})
export class FormGlobalPolicyDialogRuleComponent implements OnInit {
    @Input() rule: any;
    @Input() monDialogId: string = '';
    @Output() setForm = new EventEmitter<any>();

    ruleType: any;
    cRule: any;
    countList: string[] = [];
    standardBlacklist: string[] = [];
    headerClass = '';
    pushHeader = false;
    form: any = {};

    constructor (
        private policyFormHelperService: PolicyFormHelperService,
    ) {}

    ngOnInit (): void {
        this.ruleType = this.policyFormHelperService.getSubjectTypeOption(this.rule.type);
        this.cRule = safeClone(this.rule);
        if (typeof this.cRule.case_sensitive !== 'boolean') {
            this.cRule.case_sensitive = true;
        }
        this.cRule.inverse = this.cRule.inverse || false;
        this.cRule.multiline = this.cRule.multiline || false;
        this.cRule.sub_entry = this.cRule.sub_entry || '';
        this.cRule.sub_entry = this.cRule.sub_entry.split(',').filter(Boolean);
        this.countList = [
            'external_link_count',
            'incoming_link_count',
            'page_title_length',
            'link_text_length',
            'image_text_length',
            'header_text_length',
        ];
        this.standardBlacklist = [
            'readability_level',
            'file_size',
            'image_size',
            'meta_header',
            'meta_header_length',
        ].concat(this.countList);
        this.setupHeaderClasses();
    }

    private setupHeaderClasses (): void {
        this.headerClass = '';
        this.pushHeader = false;

        if (!(typeof this.ruleType.description === 'string' && this.ruleType.description.length > 0)) {
            // Push the title 5px if no description is available
            this.pushHeader = true;
            this.headerClass += 'pt-1';
        }
    }
}
